module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_1_5_1-ea44a8bff427eb1909d8c7bca44ac4f9.webp";